module.exports = __webpack_public_path__ + "static/image_8-74f73566a2d830579f6c8ed031059c13.jpg";